module.exports = __webpack_public_path__ + "static/img/friend-img.7298b07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/friend-img.png
// module id = 15DV
// module chunks = 1